import packingRequest from "../request/packing"
import configServer from "../../configs/server"
import { getAccessToken } from "../AuthServices"
import queryString from "qs"

const apiRequest = packingRequest()

export const listOrdersReport = (data) => {
    return apiRequest({
        url: '/exporter/shipped-orders',
        method: 'POST',
        data: data
    })
}

export const getExportOrdersReport = (params) => {
    return apiRequest({
        url: '/exporter/shipped-orders/export-csv',
        method: 'POST',
        data: params
    })
}

export const statisticSKU2D = (data) => {
    return apiRequest({
        url: 'exporter/sku/statistic/2d',
        method: 'POST',
        data: data
    })
}

export const statisticSKU3D = (data) => {
    return apiRequest({
        url: 'exporter/report/production-statistic',
        method: 'POST',
        data: data
    })
}

export const statisticPushedSku = async (query) => {
    return apiRequest({
        url: `exporter/statistic/sku/received?${query}`,
        method: 'GET'
    })
}


export const statisticAverageSku = async (query, data) => {
    return apiRequest({
        url: `order/skus/list-products?${query}`,
        method: 'POST',
        data: data
    })
}

export const statisticAverageSkuV3 = async (query, data) => {
    return apiRequest({
        url: `order/v3/skus/list-products?${query}`,
        method: 'POST',
        data: data
    })
}

export const productionTimeStatistics = async (query, data) => {
    return apiRequest({
        url: `report/production-time-statistics?${query}`,
        method: 'GET',
        data: data
    })
}

export const statisticUserAction = async (payload) => {
    return apiRequest({
        url: `exporter/report/user-actions`,
        method: 'POST',
        data: payload
    })
}

export const statisticCutoff = async (payload) => {
    return apiRequest({
        url: `exporter/report/cutoff`,
        method: 'GET',
        params: payload
    })
}

export const getExportCutoff = (params) => {
    const baseUrl = configServer.url
    const query = queryString.stringify(params)

    return `${baseUrl}/exporter/report/cutoff/csv?${query}`
}

export const getExportStatisticUserAction = (params) => {
    const baseUrl = configServer.url
    const query = queryString.stringify(params, { arrayFormat: 'bracket' })
    const token = getAccessToken()

    return apiRequest({
        url: `exporter/report/user-actions?accessToken=${token}&${query}`,
        method: 'GET',
    })
}

export const getUsersActionDetail = (params = {}) => {
    return apiRequest({
        url: `exporter/report/user-actions/detail`,
        method: 'POST',
        data: params
    })
}

// @FAC-25799 — popup "Chi tiết sản xuất" ở màn Quản lý đơn lỗi.
// data: {reference_numbers: ['123_1', ...]} → mỗi item 8 công đoạn, logs mới → cũ
export const getIssueStageLogs = (data = {}) => {
    return apiRequest({
        url: `exporter/issues/stage-logs`,
        method: 'POST',
        data
    })
}

export const getActionKeys = async () => {
    return apiRequest({
        url: `exporter/report/action-keys`,
        method: 'GET'
    })
}

export const getExportUsersActionDetail = (data) => {
    return apiRequest({
        url: `exporter/report/user-actions/export`,
        method: 'POST',
        data,
    })
}

export const staticsOrderHour = async (params) => {
    return apiRequest({
        url: `order/report/report-each-hour-by-day`,
        method: 'GET',
        params
    })
}

export const staticsOrderByPeriod = async (params) => {
    return apiRequest({
        url: `order/report/report-by-period`,
        method: 'GET',
        params
    })
}

export const getStatisticCutoff = async (params) => {
    return apiRequest({
        url: `exporter/report/cutoff/v2`,
        method: 'GET',
        params: params
    })
}

export const exportCutoffV2 = (params) => {
    const baseUrl = configServer.url
    const query = queryString.stringify(params)

    return `${baseUrl}/exporter/report/cutoff/v2/csv?${query}`
}

export const getStatisticProductResult = async (query) => {
    return apiRequest({
        url: `exporter/operation-report/production-result?${query}`,
        method: 'GET'
    })
}

export const getStatisticProcessQuality = (data) => {
    return apiRequest({
        url: `exporter/operation-report/stage-quality`,
        method: 'POST',
        data,
    })
}

export const getStatisticCustomerService = async (query) => {
    return apiRequest({
        url: `exporter/operation-report/customer-service?${query}`,
        method: 'GET'
    })
}